import { NewsCategory } from "@/@types";
import { NewsCategoryResponse } from "../../news/models/NewsCategoryResponse";

export function mapNewsCategory(response: NewsCategoryResponse[]): NewsCategory[] {
    return response.map(category => ({
        name: category.name,
        slug: category.slug,
        order: category.order,
    }))
}